import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor(private http: HttpClient) {}

  getCommunicationHistory(request: any): Observable<any> {
    return this.http.post('/TgNewUI/CandidateZone/Ajax/CommunicationHistory',request);
  }
}
